import { PsDocumentState } from './PsDocumentState';
import { PsDate } from '../../model/PsDate';

export class PsDocument {

    _id; // number
    _name; // string
    _state; // PsDocumentState
    _endDate; // PsDate | null
    _startDate; // PsDate | null
    _outsource; // string
    _contractor; // string
    _apiDocument; // for attachment page

    _workerId; // number
    _machineId; // number
    _outsourceId; // number
    _contractorId; // number

    constructor(
        id,
        name,
        state,
        endDate,
        startDate,
        outsource,
        contractor,
        apiDocument,
        workerId,
        machineId,
        outsourceId,
        contractorId,
    ) {
        this._id = id;
        this._name = name;
        this._state = state;
        this._endDate = endDate;
        this._startDate = startDate;
        this._outsource = outsource;
        this._contractor = contractor;
        this._apiDocument = apiDocument;
        this._workerId = workerId;
        this._machineId = machineId;
        this._outsourceId = outsourceId;
        this._contractorId = contractorId;
    }

    static fromAPIDocuments(documents) {
        return documents.map((document) => PsDocument.fromAPIDocument(document));
    }

    static fromAPIDocument(document) {
        const {
            id,
            name,
            company,
            end_date,
            start_date,
            contractor,
            document_state,
            worker,
            machine,
        } = document;

        return new this(
            id,
            worker ? name + ' - ' + worker.name + ' ' + worker.last_name : name,
            PsDocumentState.fromAPIDocumentState(document_state),
            end_date ? PsDate.fromDate(end_date) : null,
            start_date ? PsDate.fromDate(start_date) : null,
            company ? company.name : '',
            contractor ? contractor.name : '',
            document,
            worker ? worker.id : -1,
            machine ? machine.id : -1,
            company ? company.id : -1,
            contractor ? contractor.id : -1,
        );
    }

    id() {
        return this._id;
    }

    name() {
        return this._name;
    }

    state() {
        return this._state;
    }

    endDate() {
        return this._endDate ? this._endDate.toDateString() : 'N/A';
    }

    startDate() {
        return this._startDate ? this._startDate.toDateString() : 'N/A';
    }

    contractor() {
        return this._contractor;
    }

    outsource() {
        return this._outsource;
    }

    stateData() {
        return this.state().data();
    }

    apiDocument() {
        return this._apiDocument;
    }

    hasWorkerId() {
        return this.workerId() !== -1;
    }

    workerId() {
        return this._workerId;
    }

    hasMachineId() {
        return this.machineId() !== -1;
    }

    machineId() {
        return this._machineId;
    }

    outsourceId() {
        return this._outsourceId;
    }

    contractorId() {
        return this._contractorId;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/document/list/PsDocument.js